<script setup lang="ts" generic="T extends string">
import {
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectRoot,
  SelectTrigger,
  SelectViewport,
} from 'reka-ui'
import { computed } from 'vue'
import IconCustom from '@/components/IconCustom.vue'
import $typo from '@/styles/typografy.module.css'

const props = defineProps<{
  options: { label: string; value: T }[]
  placeholder?: string
}>()

const modelValue = defineModel<T>({ required: true })

const selectedLabel = computed(() => {
  const option = props.options.find((o) => o.value === modelValue.value)
  return option?.label ?? props.placeholder ?? ''
})
</script>

<template>
  <SelectRoot v-model="modelValue">
    <SelectTrigger
      :class="$typo.openSans14"
      class="cursor-pointer w-full px-3.75 h-10 flex items-center justify-between leading-none bg-button rounded-[calc(var(--border-radius)*1px)] outline-none text-text"
    >
      <span>{{ selectedLabel }}</span>
      <IconCustom
        class="text-text transition-transform duration-200 [[data-state=open]>&]:rotate-180"
        size="24"
        ligature="keyboard_arrow_down"
      />
    </SelectTrigger>
    <SelectContent
      position="popper"
      :side-offset="4"
      class="w-(--reka-select-trigger-width) bg-button rounded-[calc(var(--border-radius)*1px)] overflow-hidden z-1100 shadow-lg data-[state=open]:animate-dropdown-in data-[state=closed]:animate-dropdown-out"
    >
      <SelectViewport>
        <SelectItem
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          :class="$typo.openSans14"
          class="px-3.75 h-10 flex items-center cursor-pointer leading-none outline-none text-text"
        >
          <SelectItemText>{{ option.label }}</SelectItemText>
        </SelectItem>
      </SelectViewport>
    </SelectContent>
  </SelectRoot>
</template>
